import { isNullOrUndefined } from './isNullOrUndefined';

export function formatCurrency(
  value: number | undefined | null,
  minimumFractionDigits: number = 0,
  maximumFractionDigits?: number,
) {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits ?? minimumFractionDigits,
  });

  if (isNullOrUndefined(value)) {
    return '';
  }

  return currencyFormatter.format(value);
}
